export default __webpack_public_path__ + "static/media/unauth-illustraction.408856a0.svg";